import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function createOrganizationInvitation(payload) {
  try {
    const response = await authFetch(`${BACKEND_URL}/organization/invitations`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json().catch(() => ({}));
    return {
      success: response.ok && data?.success === true,
      message: data?.message ?? "",
      data: data?.data ?? null,
    };
  } catch (error) {
    console.error("[createOrganizationInvitation] failed:", error);
    return {
      success: false,
      message: "조직 초대 요청 중 오류가 발생했습니다.",
      data: null,
    };
  }
}
